import { render, staticRenderFns } from "./ActivityBox.vue?vue&type=template&id=296f9b76&scoped=true&"
import script from "./ActivityBox.vue?vue&type=script&lang=js&"
export * from "./ActivityBox.vue?vue&type=script&lang=js&"
import style0 from "./ActivityBox.vue?vue&type=style&index=0&id=296f9b76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296f9b76",
  null
  
)

export default component.exports